export enum CreditCardBrand {
  MASTERCARD = "mastercard",
  VISA = "visa",
  DISCOVER = "discover",
  UNKOWN = "unknown",
}
